document.addEventListener('DOMContentLoaded', function() {
  // Wait for the app block to load
  const checkForAppPrice = setInterval(() => {
    const appPriceElement = document.querySelector('.infiniteoptions-price .price-item--regular');
    const templatePriceElement = document.querySelector('.product-meta__price-list-container .price');
    
    if (appPriceElement && templatePriceElement) {
      // Replace the template price with app price
      templatePriceElement.innerHTML = appPriceElement.innerHTML;
      
      // Set up observer to watch for price changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            templatePriceElement.innerHTML = appPriceElement.innerHTML;
          }
        });
      });
      
      observer.observe(appPriceElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      clearInterval(checkForAppPrice);
    }
  }, 100);
});